"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.white = exports.gr = exports.black = void 0;
var _styledComponents = require("styled-components");
var _breakpoints = require("../breakpoints");
var _index = _interopRequireDefault(require("./index.styled"));
const white = exports.white = (0, _styledComponents.css)`
  color: #000;
  background-color: #fff;
  svg {
    fill: #000;
  }
  ${_index.default.PageNavigation},
  ${_index.default.SectionName},
  ${_index.default.DropDown} {
    color: #000;
    background-color: #fff;
    svg {
      fill: #000;
    }
  }
`;
const black = exports.black = (0, _styledComponents.css)`
  color: #fff;
  background-color: #0d0202;
  svg {
    fill: #fff;
  }
  ${_index.default.PageNavigation},
  ${_index.default.SectionName},
  ${_index.default.DropDown} {
    color: #fff;
    background-color: #0d0202;
    svg {
      fill: #fff;
    }
  }
`;
const gr = exports.gr = (0, _styledComponents.css)`
  /* TODO: Re-Introduce Glassmorphic Background in Future iteration */
  /* -webkit-backdrop-filter: blur(6px) saturate(100%); */
  /* backdrop-filter: blur(6px) saturate(100%); */
  /* border-bottom: 1px solid rgba(234,234,234, 0.1); */

  ${_index.default.Container} {
    max-width: 1280px;
  }

  ${_index.default.Model} {
    font-family: "DecimaMonoPro";
    font-weight: 300;
    font-size: 36px;
    line-height: 36px;
    border-right: unset;
    letter-spacing: 0.1em;

    ${(0, _breakpoints.breakpoint)("tablet", "down")} {
      font-size: 30px;
      line-height: 30px;
    }

    ${(0, _breakpoints.breakpoint)("mobile", "down")} {
      font-size: 24px;
      line-height: 24px;
    }

    & ${_index.default.ModelButton} {
      display: flex;
      gap: 30px;
      align-items: center;

      ${(0, _breakpoints.breakpoint)("tablet", "down")} {
        gap: 25px;
      }

      ${(0, _breakpoints.breakpoint)("mobile", "down")} {
        gap: 20px;
      }
    }

    & span {
      // TODO: Remove or replace with text-box-* css attributes (This is a temporary solution to get around font ascender/descender issues)
      height: 30px;
      ${(0, _breakpoints.breakpoint)("tablet", "down")} {
        height: 24px;
      }
      ${(0, _breakpoints.breakpoint)("mobile", "down")} {
        height: 20px;
      }
    }

    // TODO: Consider using border-right instead
    & ::after {
      content: "";
      background-color: white;
      height: 26px;
      width: 1px;

      ${(0, _breakpoints.breakpoint)("tablet", "down")} {
        height: 22px;
      }
      ${(0, _breakpoints.breakpoint)("mobile", "down")} {
        height: 18px;
      }
    }
    svg {
      height: 1em;
      display: flex;
    }
  }

  background-color: #000000;
  border-bottom: unset;
  color: #fff;
  ${_index.default.PageNavigation},
  ${_index.default.SectionName},
  ${_index.default.DropDown},
  ${_index.default.DropdownButton} {
    color: #fff;
    background-color: #000000;
    svg {
      fill: #fff;
    }
  }

  ${(0, _breakpoints.breakpoint)("desktop", "up")} {
    ${_index.default.LinkItem}:first-of-type {
      margin-left: 2px;
    }
  }

  ${_index.default.Link} {
    // !important added to override LinksScrollWrapper changes made in [LEXC-29181]
    font-family: akkurat-mono !important;
    font-size: 11px !important;
    letter-spacing: 0.55px !important;
  }

  ${_index.default.SectionName} {
    font-family: akkurat-mono;
    letter-spacing: 0.1em;
  }
`;